import DynamicIcon from "./dynamic_icon";
import PrimaryButton from "./primary_button";

/**
 * BackButton
 */

type Props = {
  onClick: () => void,
};

export const BackButton = ({ onClick }: Props) => {
  return (
    <div className="w-[6rem]">
      <PrimaryButton
        buttonColor='red'
        startIcon={<DynamicIcon nameIcon="ArrowBack" size={25} className="text-white" />}
        onClick={onClick}>
        Voltar
      </PrimaryButton>
    </div>
  );
}